import React from "react";
import { Activity } from "lucide-react";

/**
 * GOV.UK-style status banner indicating how many workshops have been loaded
 * vs the 22-workshop target. Appears above the main header.
 */
export default function StatusBanner({ loaded, target }) {
  const pct = target ? Math.min(100, Math.round((loaded / target) * 100)) : 0;
  const complete = loaded >= target;
  return (
    <div
      className="bg-slate-50 border-b border-slate-200 fel-fade-in"
      data-testid="status-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="flex items-center gap-3 text-sm text-slate-700">
          <span
            className="inline-flex items-center gap-1.5 bg-white border border-slate-300 text-slate-800 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider"
            data-testid="status-phase-tag"
          >
            <Activity className="h-3 w-3" /> Live
          </span>
          <span>
            <span className="font-mono font-semibold" data-testid="status-loaded">
              {loaded}
            </span>
            <span className="text-slate-500"> of </span>
            <span className="font-mono font-semibold" data-testid="status-target">
              {target}
            </span>
            <span className="text-slate-500">
              {" "}
              workshops ingested
              {complete
                ? " · dataset complete"
                : " · awaiting further batches"}
            </span>
          </span>
        </div>
        <div
          className="w-full sm:w-64 h-1.5 bg-slate-200 overflow-hidden"
          data-testid="status-progress"
          aria-label="Ingestion progress"
        >
          <div
            className="h-full bg-[#2F4F4F] transition-all"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
    </div>
  );
}
